import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { TCancellationPolicy } from '@/services/types/booking/cancellationDetail';
import { getCoreApi } from '@/utility/getCoreApi';

export type TGetCancellationPolicyInput = {
  booking_id?: number;
  // Cancellation policy may depend on booking start date.
  // It is not going to be sent to the API, just used for SWR cache key.
  booking_start_date?: string;
  free_period?: number;
  locale?: string;
  owner_edit_listing?: boolean;
  payment?: boolean;
  policy?: string;
  refund?: boolean;
  rental_id?: number;
  v?: number;
};

export const useGetCancellationPolicy = ({
  booking_start_date,
  ...input
}: TGetCancellationPolicyInput) => {
  return useSWR(
    { url: `${getCoreApi()}/static/cancellation-policy`, params: input, booking_start_date },
    ({ url, params }) => apiRequest<TCancellationPolicy>({ url, params }, true, true),
    {
      revalidateOnMount: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );
};
